import * as p0 from "./plugins/appleMusic.desktop/native";
import * as p1 from "./plugins/consoleShortcuts/native";
import * as p2 from "./plugins/fixSpotifyEmbeds.desktop/native";
import * as p3 from "./plugins/fixYoutubeEmbeds.desktop/native";
import * as p4 from "./plugins/openInApp/native";
import * as p5 from "./plugins/translate/native";
import * as p6 from "./plugins/voiceMessages/native";
import * as p7 from "./plugins/xsOverlay/native";
import * as p8 from "./plugins/youtubeAdblock.desktop/native";
export default {
"AppleMusicRichPresence":p0,
"ConsoleShortcuts":p1,
"FixSpotifyEmbeds":p2,
"FixYoutubeEmbeds":p3,
"OpenInApp":p4,
"Translate":p5,
"VoiceMessages":p6,
"XSOverlay":p7,
"YoutubeAdblock":p8,
};